module.exports = __webpack_public_path__ + "img/card-payment-acceptance.e003b71d.png";